// extracted by mini-css-extract-plugin
module.exports = {"container":"feedbackItem_container__1Rgg7"};